/* js小工具 对标 vue2过滤器 */

import { Message } from 'element-ui';
import auth from "@/v2/utils/auth";

// 浮点数精确保留n位, 整数不会出现浮点
function toPointFixed (value, fixValue = 2) {
  const target = parseFloat(value).toFixed(fixValue)
  if (target.indexOf('.') === -1) return value
  const values = target.split('.')
  let num = parseInt(values[1]) // 看看小数的整型
  if (num > 10 || num === 0) { // 将小数如9.10、9.00中的0去掉
    num = values[1].replace('0', '').replace('0', '') // 9.00时，num的长度为0
  } else {
    num = values[1] // 保留 9.01的01情况
  }
  if (num.length > 0) {
    return values[0] + '.' + num
  } else {
    return values[0]
  }
}

// 日期格式化
function formatDate (date, type) {
  if (!date) {
    return '--'
  }
  let dateTime = '--'
  let getDate = date
  if (typeof date !== 'object') {
    if (typeof date === 'string' && date.indexOf('+') >= 0) {
      date = date.split('+')[0]
    }
    getDate = new Date(date)
  }
  const year = getDate.getFullYear()
  const month = addZero(getDate.getMonth() + 1)
  const day = addZero(getDate.getDate())
  const hours = addZero(getDate.getHours())
  const minutes = addZero(getDate.getMinutes())
  switch (type) {
    case 'yyyy-MM-dd':
      dateTime = year + '-' + month + '-' + day
      break;
    case 'MM-dd':
      dateTime = month + '-' + day
      break;
    case 'M月d日 hhmm':
      dateTime = month + '月' + day + '日 ' + hours + ':' + minutes
      break;
    case 'hhmm':
      dateTime = hours + ':' + minutes
      break;
    case 'yyyy/mm/dd':
      dateTime = year + '/' + month + '/' + day;
      break;
    default:
      dateTime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes
      break;
  }
  return dateTime
}

function addZero (val) {
  if (val < 10) {
    return '0' + val
  } else {
    return val
  }
}

function examTypeName (type, num = 4) {
  const typeNames = [
    '',
    '学前测试', // 蓝色
    '周练', // 蓝色
    '单元练习', // 蓝色
    '月练', // 蓝色
    '期中考试', // 绿色
    '期末考试', // 绿色
    '模拟考试',  // 橙色
    '其它' // 蓝色
  ]
  return typeNames[type] ? typeNames[type].substring(0, num) : type + ''
}

function gradingName (type) {
  const typeNames = [
    '',
    '批阅未开始',
    '批阅中…',
    '暂停中…',
    '结束批阅'
  ]
  return typeNames[type] ? typeNames[type] : type + ''
}

function getGradeName (index) {
  const list = ['', '一年级', '二年级', '三年级', '四年级', '五年级', '六年级', '初一', '初二', '初三', '高一', '高二', '高三']
  return list[parseInt(index)]
}

function quesNumLabel (ques) {
  if (ques.bigNum && ques.smallNum) {
    return ques.bigNum + '.' + ques.smallNum
  } else {
    return `第${ques.question || ques.num}题`
  }
}

function standardQuestionNumber (question) {
  return question.bigNum && question.smallNum ? question.bigNum + "." + question.smallNum : question.question ? question.question : question.num ? question.num : '--'
}

function transformToChinese (num) {
  var a = numToChn(num);
  num = Math.floor(num);
  var unitPos = 0;
  var strIns = "",
    chnStr = "";
  var needZero = false;

  if (num === 0) {
    return chnNumChar[0];
  }
  while (num > 0) {
    var section = num % 10000;
    if (needZero) {
      chnStr = chnNumChar[0] + chnStr;
    }
    strIns = sectionToChinese(section);
    strIns += section !== 0 ? chnUnitSection[unitPos] : chnUnitSection[0];
    chnStr = strIns + chnStr;
    needZero = section < 1000 && section > 0;
    num = Math.floor(num / 10000);
    unitPos++;
  }

  return chnStr + a;
}

function numToChn (num) {
  var index = num.toString().indexOf(".");
  if (index != -1) {
    var str = num.toString().slice(index);
    var a = "点";
    for (var i = 1; i < str.length; i++) {
      a += chnNumChar[parseInt(str[i])];
    }
    return a;
  } else {
    return "";
  }
};

// 定义在每个小节的内部进行转化的方法，其他部分则与小节内部转化方法相同
function sectionToChinese (section) {
  var str = "",
    chnstr = "",
    zero = false,
    count = 0; // zero为是否进行补零， 第一次进行取余由于为个位数，默认不补零
  while (section > 0) {
    var v = section % 10; // 对数字取余10，得到的数即为个位数
    if (v == 0) {
      // 如果数字为零，则对字符串进行补零
      if (zero) {
        zero = false; // 如果遇到连续多次取余都是0，那么只需补一个零即可
        chnstr = chnNumChar[v] + chnstr;
      }
    } else {
      zero = true; // 第一次取余之后，如果再次取余为零，则需要补零
      str = chnNumChar[v];
      str += chnUnitChar[count];
      chnstr = str + chnstr;
    }
    count++;
    section = Math.floor(section / 10);
  }
  return chnstr;
}

function typeName (key, index) {
  const obj = {
    assignVersion: ['', '分配到教师', '分配到学校'],
    assignType: ['平均分配', '效率分配', '分配', '定额分配'],
    reviewStatus: ['', '未批阅', '批阅中', '暂停批阅', '批阅完成'],
    dispenseMethod: ['', '按老师分配', '按学校分配']
  }
  return obj[key][index]
}

function enterFullScreen () {
  const element = document.documentElement; // 获取整个文档对象
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) { /* Firefox */
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
    element.webkitRequestFullscreen();
  } else if (element.msRequestFullscreen) { /* IE/Edge */
    element.msRequestFullscreen();
  }
}

function toggleFullScreen () {
  if (isFullScreen()) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  }
}

function disableEscExitFullscreen (event, callback) {
  console.log(event)
  if (event.keyCode === 27 && isFullScreen()) {
    event.preventDefault();
    console.log('已禁用 ESC 退出全屏功能');
    if (callback) {
      callback()
    }
  }
}

function isFullScreen () {
  return document.fullscreenElement || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement
}

// 深拷贝
function deepCopy (obj, hash = new WeakMap()) {
  // 处理非对象类型
  if (typeof obj !== 'object' || obj === null) {
    return obj
  }

  // 如果obj是日期或正则对象直接返回一个新对象
  if (obj instanceof Date) {
    return new Date(obj)
  }

  if (obj instanceof RegExp) {
    return new RegExp(obj)
  }

  // 如果循环引用则直接返回引用
  if (hash.has(obj)) {
    return hash.get(obj)
  }

  // 处理数组
  if (Array.isArray(obj)) {
    let newArray = []
    hash.set(obj, newArray)
    for (let i = 0; i < obj.length; i++) {
      newArray[i] = deepCopy(obj[i], hash)
    }
    return newArray
  }
  // 处理对象
  let newObj = {}
  hash.set(obj, newObj)
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      newObj[key] = deepCopy(obj[key], hash)
    }
  }

  return newObj
}

// 设置cookie
function setCookie (name, value, minutes) {
  var expires = "";

  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }

  document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
}

// 获取cookie
function getCookie (name) {
  var cookieArr = document.cookie.split("; ");
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");
    /* 不使用 decodeURIComponent，因为如果值中不含特殊字符，则不需要解码
       如果需要解码，可以使用 decodeURIComponent(cookiePair[1]) */
    if (name === cookiePair[0]) {
      return cookiePair[1];
    }
  }
  return null;
}

// 获取坐标
function getRect (ossUrl) {
  if (ossUrl && ossUrl.includes('crop,')) {
    const rectRanges = ossUrl.split('/crop,')[1].split(',');
    const keys = ['x', 'y', 'w', 'h']
    const rect = {}
    for (let index = 0; index < keys.length; index++) {
      const key = keys[index];
      rect[key] = parseInt(rectRanges[index].replace(key + '_', ''))
    }
    return rect
  }
  return []
}

// 指定位置转换大写
function capitalizeAtPosition (string, index) {
  if (index < 0 || index >= string.length) {
    throw new Error('Index out of bounds');
  }

  return string.slice(0, index) + string.charAt(index).toUpperCase() + string.slice(index + 1);
}

// 指定范围位置转换为大写
function capitalizeRange (string, start, end) {
  if (start < 0 || end > string.length || start > end) {
    throw new Error('Invalid range');
  }

  const firstPart = string.slice(0, start);
  const capitalizedPart = string.slice(start, end).toUpperCase();
  const lastPart = string.slice(end);

  return firstPart + capitalizedPart + lastPart;
}

// 检测是否空值
function isEmpty (val) {
  if (typeof val === 'undefined' || val === null || val === '') {
    return true
  }
  return false
}

// 根据指定key进行排序
function sortArrayByKey (list, key) {
  return list.sort((item1, item2) => {
    const item1_key = item1[key]
    const item2_key = item2[key]

    const numA = parseInt(item1_key.replace(/\D/g, ''), 10);
    const numB = parseInt(item2_key.replace(/\D/g, ''), 10);

    // 如果都是数字，则按数字排序
    if (!isNaN(numA) && !isNaN(numB)) {
      return numA - numB;
    }

    // 如果一个是数字，另一个不是，则数字优先
    if (!isNaN(numA)) return -1;
    if (!isNaN(numB)) return 1;

    // 都是非数字，则按字符串排序
    return item1_key.localeCompare(item2_key);
  });
}

function downloadFile (blob, fileName) {
  // 创建下载链接并点击下载
  const url = URL.createObjectURL(blob);
  download(url, fileName)
}

function generateDateTimeString () {
  const now = new Date();
  const month = ('0' + (now.getMonth() + 1)).slice(-2); // 月份是从0开始的
  const day = ('0' + now.getDate()).slice(-2);
  return `${month}${day}`;
}

function download (url, fileName) {
  const a = document.createElement('a');
  a.style.display = 'none';
  a.setAttribute('target', '_blank');
  a.href = url;
  if (fileName) {
    a.download = fileName
  }
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

function deepClone (data) {
  return JSON.parse(JSON.stringify(data));
}

// 是否是相同题目
function sameTopic (target, source) {
  return target.bigNum + target.smallNum + '' === source.bigNum + source.smallNum + ''; // 大题号 + 小题号一样就是相同题目
}

// 字段排序
function sortField (field) {
  return field.split('').sort((a, b) => {
    if (a > b) {
      return 1;
    } else {
      return -1;
    }
  }).join('');
}

// 是否是重叠词AAB、BB
export const isReduplication = (field) => {
  let repeat = false;
  for (let i = 0; i < field.length; i++) {
    let remain = field.substr(i + 1);
    if (remain.indexOf(field.charAt(i)) > -1) {
      repeat = true;
      break;
    }
  }
  return repeat;
}

// 将输入值转换为大写并替换全角字符为半角字符
// @param {String} val - 输入的值
// @returns {String} - 处理后的值
function transformInput (val) {
  return val.toUpperCase().replace(/[\uff01-\uff5e]/g, char => String.fromCharCode(char.charCodeAt(0) - 65248));
}

async function copyTip (event) {
  // 保留原始格式
  const lines = event.currentTarget.innerText.split('\n').filter(line => line.trim() !== '')
  lines.push('用户名：' + this.userInfo.nickName)
  lines.push('复制时间：' + new Date().toLocaleString())
  // 获取提示内容
  const content = lines.join('\n')
  // 优先使用 execCommand 方式复制,兼容iframe场景
  try {
    const textarea = document.createElement('textarea')
    textarea.value = content
    document.body.appendChild(textarea)
    textarea.select()
    const result = document.execCommand('copy')
    document.body.removeChild(textarea)
    if (result) {
      Message.success('复制成功')
      return
    }
  } catch (err) {
    console.warn('execCommand copy failed', err)
  }

  // 降级使用 Clipboard API
  try {
    await navigator.clipboard.writeText(content)
    Message.success('复制成功')
  } catch (err) {
    Message.warning('浏览器权限受限，请手动选中内容后按 Ctrl+C (Mac 用户请按 Command+C) 复制')
  }
}

function transformUrlParams (data) {
  let ret = ''
  if (typeof data === 'string') {
    ret = '?' + data
  } else if (typeof data === 'object') {
    let first = true;
    for (const key in data) {
      ret += (first ? '?' : '&') + key + '=' + encodeURIComponent(data[key]);
      first = false;
    }
  }
  return ret
}

var chnNumChar = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
var chnUnitSection = ["", "万", "亿", "万亿", "亿亿"];
var chnUnitChar = ["", "十", "百", "千"];
const markTypeDict = {
  FIRST: '正常卷批阅',
  SECOND: '仲裁卷评阅',
  THIRD: '三评',
  LEADER: '异常卷批阅'
}

function subjectExamName (exam) {
  if (exam.isTwo) {
    return `${exam.subjectName} (二卷)`
  } else {
    return `${exam.subjectName}${exam.hasTwo ? ' (主卷)' : ''}`
  }
}

function isAuth (name) {
  let result = auth.checkAuthPerm(name)
  if (!result) {
    // 这里判断pathArray，为了兼容新的权限是和业务逻辑相关的情况
    // 比如单科考试的"年级报告"，需要检查pathArray中是否包含"School-Report"
    // 而"School-Report"权限是和某个考试有关，需要根据考试id调用接口单独获取
    // 搜索标记：School-Report
    const pathArray = JSON.parse(YJ_SCHOOL_STORAGE.getItem("pathArray"));
    if (Array.isArray(name)) {
      for (let index = 0; index < name.length; index++) {
        const element = name[index];
        if (pathArray && pathArray.indexOf(element) > -1) {
          result = true
          break
        }
      }
    } else {
      result = pathArray && pathArray.indexOf(name) > -1
    }
  }
  return result
}

// 判断是否具有更多权限
function isMoreAuth (code, moreAuths, examId) {
  let result = false
  // 如果examId为空，则直接判断code是否具有权限
  if (this.isEmpty(examId)) {
    return this.isAuth(code)
  }

  // 检测考试权限
  if (moreAuths.includes('exam')) {
    // 如果code是数组，则遍历数组，判断每个元素是否具有权限
    if (Array.isArray(code)) {
      for (let index = 0; index < code.length; index++) {
        const element = code[index];
        result = this.getExamPermCache(element, examId) || this.isAuth(element)
        if (result) {
          return true
        }
      }
    } else {
      result = this.getExamPermCache(code, examId) || this.isAuth(code)
    }
  }

  return result
}

// 根据code和examId获取考试权限缓存
function getExamPermCache (code, examId) {
  const value = `${code}-${examId},`;
  const cacheStr = YJ_SCHOOL_STORAGE.getItem(`perm-cache`);
  return cacheStr ? cacheStr.includes(value) : false;
}

// 设置考试权限缓存
function setExamPermCache (code, examId, isExist) {
  // 构造缓存值
  const value = `${code}-${examId},`;
  // 获取缓存字符串
  let cacheStr = YJ_SCHOOL_STORAGE.getItem(`perm-cache`) || '';
  // 判断缓存字符串中是否包含该值
  const hasValue = cacheStr.includes(value);

  // 如果isExist为true且缓存字符串中不包含该值，则将值添加到缓存字符串中
  if (isExist && !hasValue) {
    cacheStr = value + cacheStr;
    // 如果isExist为false且缓存字符串中包含该值，则将值从缓存字符串中移除
  } else if (!isExist && hasValue) {
    cacheStr = cacheStr.replace(value, '');
  }
  // 将缓存字符串存入缓存
  YJ_SCHOOL_STORAGE.setItem(`perm-cache`, cacheStr);
}

/**
 * 获取dom下包含 shadowRoot 的节点
 *
 * shadow root是什么
 * https://blog.csdn.net/m0_57236802/article/details/140591567
 *
 * @since 2025-04-21
 * @author sunanguang
 * @param {Node} dom - 节点
 */
function getShadowHosts (dom) {
  const shadowHosts = []
  const walker = document.createTreeWalker(
    dom,
    NodeFilter.SHOW_ELEMENT
  )

  // 第一阶段：仅收集不操作
  while (walker.nextNode()) {
    const node = walker.currentNode
    if (node.shadowRoot) {
      shadowHosts.push(node)
    }
  }
  return shadowHosts
}

/**
 * 清理浏览器插件注入的 shadowHosts
 *
 * @since 2025-04-21
 * @author sunanguang
 * @param {Node[]} shadowHosts - 包含shadowRoot的节点
 */
function removeShadowHosts (shadowHosts) {
  // 处理空值情况（包括null/undefined）
  if (!shadowHosts) return

  // 统一转换为数组（处理单个对象的情况）
  const nodes = Array.isArray(shadowHosts) ? shadowHosts : [shadowHosts]

  nodes.forEach(node => {
    // 添加双重安全校验
    if (node && node.shadowRoot) {
      node.shadowRoot.innerHTML = ''
      node.remove()
    }
  })
}

/**
 * 清理指定节点下注入的浏览器插件
 *
 * 问题背景：
 * 部分浏览器插件会通过 Shadow DOM 注入干扰元素，
 * 这些元素会导致 html2canvas 生成的答题卡图片包含异常内容
 *
 * @since 2025-04-21
 * @author sunanguang
 * @param {Node} dom - 节点
 */
function inspectShadowDOMAndRemove (dom) {
  // 收集dom下所有包含shadowRoot的节点
  const shadowHosts = getShadowHosts(dom)
  // 移除shadowRoot内容
  removeShadowHosts(shadowHosts)
}

/**
 * 小题号正则表达式
 *
 * 题号只能包含：数字、中文、“.”、“-”、半/全角括号
 *
 * @param {string} num - 小题号
 * @returns {boolean} - 是否符合小题号正则表达式
 */
function smallQuesNumReg (num) {
  return /^[\u4e00-\u9fa5\d\.\-()（）]+$/.test(num)
}

/**
 * 转换学科列表
 *
 * @param {Array} list - 学科列表
 * @returns {Array} - 转换后的学科列表
 */
function convertSubject (list) {
  const subjectList = []
  list.forEach(item => {
    item.isWai = false
    if (getIsWai(item.subjectId)) {
      item.isWai = true
      const curSubject = subjectList && subjectList.find(subject => subject.subjectId == 0)
      if (curSubject) {
        curSubject.children.push(item)
      } else {
        subjectList.push({
          subjectCode: 0,
          subjectName: '外语',
          subjectId: 0,
          isWai: true,
          children: [item]
        })
      }
    } else {
      subjectList.push(item)
    }
  })
  return subjectList
}

/**
 *  检测是否是外语
 *
 * @param {string} subjectId - 学科id
 * @returns {boolean} - 是否符合外语
 */
function getIsWai (subjectId) {
  // 外语集合[3:英语，21：日语，22：俄语]
  const foreignLanguage = ['3', '21', '22']
  return foreignLanguage.indexOf(subjectId + '') > -1
}

export default {
  toPointFixed,
  formatDate,
  examTypeName,
  getGradeName,
  gradingName,
  quesNumLabel,
  standardQuestionNumber,
  typeName,
  transformToChinese,
  isFullScreen,
  enterFullScreen,
  toggleFullScreen,
  disableEscExitFullscreen,
  deepCopy,
  setCookie,
  getCookie,
  markTypeDict,
  getRect,
  capitalizeAtPosition,
  capitalizeRange,
  isEmpty,
  sortArrayByKey,
  downloadFile,
  download,
  generateDateTimeString,
  copyTip,
  deepClone,
  sameTopic,
  sortField,
  isReduplication,
  transformInput,
  transformUrlParams,
  subjectExamName,
  isAuth,
  isMoreAuth,
  getExamPermCache,
  setExamPermCache,
  getShadowHosts,
  removeShadowHosts,
  inspectShadowDOMAndRemove,
  smallQuesNumReg,
  convertSubject,
  getIsWai
}
